<template>
    <div class="container padding-top">

        <div>
            <div>
                <h2>新书资讯</h2>
                <ul class="news">
                    <li v-for="items in newsList" :key="items.id" >
                    <router-link :to="{path:'/newsdetail',query:{id:items.id}}">
                      <img :src="items.imgUrl || defaultImg" class="newspic"/>
                      <div class="bookText">
                        <h4>{{items.title}} </h4>
                      </div>
                      </router-link>
                    </li>

                </ul>
                <div class="more"><button @click="getMore()" v-if="showMore"> 加载更多 》</button> </div>
            </div>
        </div>
    </div>
</template>

<script>
import {getCookie} from '@/network/cookie.js'

export default {
    metaInfo() {
        return {
            title: "路上畅听" + this.$store.state.title,
            meta: [
                {
                    vmid: "keywords",
                    name: "keywords",
                    content: this.$store.state.keywords,
                },
                {
                    vmid: "description",
                    name: "description",
                    content: this.$store.state.description,
                },
            ],
        };
    },
    data() {
        return {
            newsList: [],
            sessionId: getCookie('sessionId'),
            defaultImg: require('@/assets/lsdslogo.png'),
            pageIndex: 0,
            pageSize: 40,
            showMore: true,
        };
    },
    methods: {
        getNewsList: function () {
            this.$http.get({
                url: '/xcx/new-book-information?sessionId=' + this.sessionId+'&pageSize='+this.pageSize+'&pageIndex='+this.pageIndex
            }).then(res => {
                if(res.data.data){
                    res.data.data.map(item => {
                        if(item.imgKeyUrl){
                            item.imgUrl = item.imgKeyUrl.replace('http://obj.auto-learning.com','https://objs.auto-learning.com')
                        }
                    })
                    this.newsList = [...this.newsList,...res.data.data];
                }else{
                    this.showMore = false
                }
                // this.newsList.map(item => {
                //     if(!item.imgKeyUrl){
                //         item.imgKeyUrl = this.defaultImg
                //     }
                // })
            })
        },

        getMore: function () {
            this.pageIndex++;
            this.getNewsList();
        },
        jumptoweb:function(detail){
            if(detail.authorwareType == '0'){
                this.$router.push({
                    path: 'bookdetail',
                    query:{bookId:this.detail.authorwareId}
                })
            }
            if(detail.authorwareType == '1'){
                this.$router.push({
                    path: 'booklist',
                    query:{listId:this.detail.authorwareId}
                })
            }
        }
    },
    created: function () {
        this.getNewsList();
    },
};
</script>

<style scoped>
.title {
    font-family: PingFangSCHeavy;
    font-size: 14px;
    font-weight: 600;
}
h2{padding-left: 10px;}
h4 span{
    float: right;
}
.pointer {
    cursor: pointer;
}

.pointer:hover {
    color: #42b983;
}

a {
    text-decoration: none;
}

.padding-top {
    padding-top: 50px;
}
 
.news {
    list-style: none;
    padding: 0;
}

.news li { 
    width: 200px;
    margin: 0 10px;
    height: 200px;
    float: left;
    overflow: hidden;
    margin-bottom: 20px;
    border-radius: 5px; 
    cursor: pointer;
    position: relative;
    box-shadow: 0px 0px 8px 2px rgba(173, 195, 190, 0.3);
}
.news li:hover { 
    box-shadow: 0px 0px 8px 2px rgba(121, 172, 160, 0.5);
}
.bookText{
    position: absolute;
    left: 0px;
    right: 0px;
    bottom: 0px;
    overflow: hidden;
    background-color: rgba(255, 255, 255, 1);
}
.news li:hover .bookText{
    background-color: rgba(255, 255, 255, 0.95);
}
.news li h4{
    color: #222222;
    padding: 10px;
    margin: 0;
    font-size: 12px;
    font-weight: 500;
}

.news li:hover h4{
    color: #26e2ad !important;
    font-size: 16px;
}
.newspic{
    width:100%;
}
.news li p{
    padding: 0 10px;
    color: #222222;
    overflow: hidden;
    white-space: nowrap;
    text-overflow:ellipsis;
}
.right-content ul {
    list-style: none;
    margin: 0;
    padding: 0;
}

.right-content ul li {
    padding: 10px;
}

.more {
    clear: both;
    text-align: center;
    padding: 30px 0;
}

.more button {
    color: rgba(75, 204, 170, 1);
    background: none;
    padding: 5px 10px;
    border: 1px solid rgba(75, 204, 170, 1);
    border-radius: 3px;
    cursor: pointer;
}

.more button:hover {
    background: #4bcdab;
    color: #fff;
}
</style>
